var ol = require('../dist/ol-debug');

ol.renderer.canvas.TileLayer.prototype.manageTilePyramid = function (
    frameState, tileSource, tileGrid, pixelRatio, projection, extent,
    currentZ, preload, opt_tileCallback, opt_this) {
    var tileSourceKey = ol.getUid(tileSource);
    if (!(tileSourceKey in frameState.wantedTiles)) {
        frameState.wantedTiles[tileSourceKey] = {};
    }
    var wantedTiles = frameState.wantedTiles[tileSourceKey];
    var tileQueue = frameState.tileQueue;
    var minZoom = tileGrid.getMinZoom();
    var tile, tileRange, tileResolution, x, y, z;
    var loadingTile = [];
    for (z = minZoom; z <= currentZ; ++z) {
        tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
        tileResolution = tileGrid.getResolution(z);
        for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
            for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
                if (currentZ - z <= preload) {
                    tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                    loadingTile.push(ol.tilecoord.getKeyZXY(z, x, y));
                    if (tile.getState() == ol.TileState.IDLE) {
                        wantedTiles[tile.getKey()] = true;
                        if (!tileQueue.isKeyQueued(tile.getKey())) {
                            tileQueue.enqueue([tile, tileSourceKey,
                                tileGrid.getTileCoordCenter(tile.tileCoord), tileResolution]);
                        }
                    }
                    if (opt_tileCallback !== undefined) {
                        opt_tileCallback.call(opt_this, tile);
                    }
                } else {
                    tileSource.useTile(z, x, y, projection);
                }
            }
        }
    }
    tileSource.tileCache.forEach(function (Tile, key, TileCache) {
        var image_;
        if ((Tile.state != ol.TileState.LOADING && Tile.state != ol.TileState.IDLE)
            || ~loadingTile.indexOf(key)) {
            return;
        }
        try {
            if (Tile.getImage()) {
                image_ = Tile.getImage();
                Tile.disposeInternal();
                image_.src = "";
                try {
                    TileCache.remove(key);
                } catch (e) {
                    console.warn(e)
                }
            }
        } catch (e) {
            // ресурс не поддерживает работу с изображениями
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/tilecancel.js
// module id = 25
// module chunks = 0